export default "__VITE_ASSET__CLhX61PF__"